// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Raleway, sans-serif;
}

ion-header {
  background-color: #0b0a0a;
  color: white;
  text-align: center;
  padding: 20px 0;
  height: 120px;
  display: flex;
  align-items: center;
  /* Vertically center content */
  justify-content: center;
  /* Horizontally center content */
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  --background: #0b0a0a;
  color: white;
}

h1 {
  font-family: "Cormorant Garamond", serif;
  font-size: 60px;
  /* Additional styles if needed */
}

.href {
  text-decoration: none;
  color: white;
}

/* Adjust styles for smaller screens */
@media (max-width: 768px) {
  ion-header {
    font-size: 18px;
  }
  h1 {
    font-size: 48px;
    /* Adjust font size for smaller screens */
  }
}
@media (max-height: 768px) {
  ion-header {
    height: 75px;
  }
}
@media (max-width: 480px) {
  ion-header {
    font-size: 16px;
  }
  h1 {
    font-size: 32px;
    /* Further adjust font size for mobile screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/app/header/header.page.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EAEA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;AAAF;;AAIA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EAEA,qBAAA;EACA,YAAA;AAFF;;AAKA;EAEE,wCAAA;EACA,eAAA;EACA,gCAAA;AAHF;;AAMA;EACE,qBAAA;EACA,YAAA;AAHF;;AAMA,sCAAA;AACA;EACE;IACE,eAAA;EAHF;EAMA;IACE,eAAA;IACA,yCAAA;EAJF;AACF;AAOA;EACE;IACE,YAAA;EALF;AACF;AAQA;EACE;IACE,eAAA;EANF;EASA;IACE,eAAA;IACA,gDAAA;EAPF;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: Raleway, sans-serif;\n}\n\nion-header {\n  background-color: #0b0a0a;\n  color: white;\n  text-align: center;\n  padding: 20px 0;\n  //height: 141px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  /* Vertically center content */\n  justify-content: center;\n  /* Horizontally center content */\n \n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  //padding: 20px;\n  --background: #0b0a0a;\n  color: white;\n}\n\nh1 {\n  //font-family: \"Raleway\", sans-serif;\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 60px;\n  /* Additional styles if needed */\n}\n\n.href {\n  text-decoration: none;\n  color: white;\n}\n\n/* Adjust styles for smaller screens */\n@media (max-width: 768px) {\n  ion-header {\n    font-size: 18px;\n  }\n\n  h1 {\n    font-size: 48px;\n    /* Adjust font size for smaller screens */\n  }\n}\n\n@media (max-height: 768px) {\n  ion-header {\n    height: 75px;\n  }\n}\n\n@media (max-width: 480px) {\n  ion-header {\n    font-size: 16px;\n  }\n\n  h1 {\n    font-size: 32px;\n    /* Further adjust font size for mobile screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
